import { awaitDataServiceFetcher } from '@dxb-web-ui-framework/common/domain/RestfulDataTransfer/DataService/DataServiceFetchers';
import { AccountDetails, AccountList, AccountCertificate } from '../entities';
import { IAccountRepository } from '../entities/IAccountRepository';
import { accountsListResponseDTOToAccountsListAdapter } from './accountsListResponseDTOToAccountsListAdapter';
import { accountDetailsResponseDTOToAccountDetailsAdapter } from './accountDetailsResponseDTOToAccountDetailsAdapter';
import { accountCertificateResponseDTOToAccountCertificateAdapter } from './accountCertificateResponseDTOToAccountCertificateAdapter';

class AccountRepositoryImpl implements IAccountRepository {
  constructor() {
    this.GetCustomerAccounts = this.GetCustomerAccounts.bind(this);
    this.GetCustomerAccountDetails = this.GetCustomerAccountDetails.bind(this);
    this.GetAccountCertificate = this.GetAccountCertificate.bind(this);
  }

  GetCustomerAccounts(customerId: number, retrieveSummary: boolean): Promise<AccountList> {
    return awaitDataServiceFetcher({
      payload: Object.assign({
        method: 'GET',
        url: `/secure-web/api/private/accounts/${customerId}/deposits`,
        dynamicPath: customerId,
        params: {
          retrieveSummary,
        },
        dataAdapter: accountsListResponseDTOToAccountsListAdapter,
      }),
    });
  }

  GetCustomerAccountDetails(customerId: number, accountId: number): Promise<AccountDetails> {
    return awaitDataServiceFetcher({
      payload: Object.assign({
        method: 'GET',
        url: `/secure-web/api/private/accounts/${customerId}/deposits/${accountId}`,
        dataAdapter: accountDetailsResponseDTOToAccountDetailsAdapter,
      }),
    });
  }

  GetAccountCertificate(accountId: number): Promise<AccountCertificate> {
    return awaitDataServiceFetcher({
      payload: Object.assign({
        method: 'GET',
        url: `/secure-web/api/private/accounts/certificate/${accountId}`,
        dataAdapter: accountCertificateResponseDTOToAccountCertificateAdapter,
      }),
    });
  }
}

export { AccountRepositoryImpl };
